import React, { useEffect, useState } from 'react';
import Moment from 'moment';
import {toast} from "react-toastify";
import {Link, useParams} from "react-router-dom";
import CashierAPI from "../../apis/cashierApi/CashierAPI";
import Pagination from "../assets/Pagination";
import TableLoader from "../loaders/TableLoader";
import PrinterCashier from "./PrinterCashier";
import {NumericFormat} from "react-number-format";


const RapportCashIn = () => {

    let {city} = useParams();
    const [currentPage, setCurrentPage] = useState(1);
    const [search, setSearch] = useState("");
    const [loading, setLoading] = useState(true);

    const [cashIns, setCashIns] = useState([]);
    const [cashInsNoFiltered, setCashInsNoFiltered] = useState([]);
    const [startAt, setStartAt] = useState("");
    const [endAt, setEndAt] = useState("");
    const [sources, setSources] = useState([]);


    const fetchRapportCashIns = async () => {
        try{
            const data = await CashierAPI.findRapportCashIns();
            setCashIns(data);
            setCashInsNoFiltered(data);
            setLoading(false);
        }catch(error){
            toast.error("Erreur lors du chargement du rapport des entrées caisse  !");
        }
    };

    const getCashSources = async () => {
        try{
            const data =  await CashierAPI.findCashAccounts();
            setSources(data);
            setLoading(false);
        }catch(error){
            toast.error("Erreur lors du chargement des comptes sources !");
        }
    };

    const [param, setSetting] = useState();

    const fetchSetting = async () => {
        try{
            const data =  await CashierAPI.findSetting();
            setSetting(data);
        }catch(error){
            toast.error("Erreur lors du chargement des paramettres !");
        }
    };


    //Au chargement du composant on va chercher les buses
    useEffect(() => {
        fetchRapportCashIns();
        fetchSetting();
        getCashSources();
        return () => console.log("...");
    }, []);

    const handleChangeCurrentPage = page => {
        setCurrentPage(page);
    };

    //Gestion de la recherche
    const handleSearch = ({currentTarget}) => {
        setSearch(currentTarget.value);
        setCurrentPage(1);
    };

    const itemsPerPage = 500;

    const filteredCashIns = cashIns.filter(
        t =>
            t.code.toLowerCase().includes(search.toLowerCase()) ||
            t.description.toLowerCase().includes(search.toLowerCase()) ||
            t.source.toLowerCase().includes(search.toLowerCase()) ||
            t.currency.toLowerCase().includes(search.toLowerCase())
    );

    //Pagination des données
    const paginatedCashIns = Pagination.getData(
        filteredCashIns,
        currentPage,
        itemsPerPage
    );

    //console.log(allFrets);

    let counter = 1;

    const handleStartedDate = ({currentTarget}) => {
        setStartAt(currentTarget.value);
        setCurrentPage(1);
    };

    const handleEndedDate = ({currentTarget}) => {
        setEndAt(currentTarget.value);
        setCurrentPage(1);
    };

    const handleBtns = () => {

        if(startAt !== "" && endAt === "") {
            const filtered = cashIns.filter(
                item => Moment(item.created_at).format("YYYY/MM/DD") === Moment(startAt).format("YYYY/MM/DD"));
            setCashIns(filtered);
        } else if (startAt !== "" && endAt !== "") {
            const filtered = cashIns.filter(
                item => Moment(item.created_at).format("YYYY/MM/DD") >= Moment(startAt).format("YYYY/MM/DD")
                    && Moment(item.created_at).format("YYYY/MM/DD") <= Moment(endAt).format("YYYY/MM/DD"));
            setCashIns(filtered);
        }else{
            const filtered = cashIns.filter(item=>
                Moment(item.created_at).format("YYYY/MM/DD") >= Moment(startAt).format("YYYY/MM/DD"));
            setCashIns(filtered)
        }

    };

    function calculTotalAllCurrency(data) {
        let totalUSD = 0;
        let totalCDF = 0;
        data.map((d) =>  {
            if (d.currency === "FC"){
                totalCDF += d.amount;
            }else{
                totalUSD += d.amount;
            }
        });
        return {totalUSD, totalCDF}
    }


    return (
        <div className="container">
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <h2 className="p-2 fw-bold text-success">Rapport des entrées caisse</h2>
                        <div className="card-body">
                            <div className="row">
                                <div className="col">
                                    <h2 className="card-title">
                                        Total : <b className="text-primary">{cashInsNoFiltered.length} </b>
                                    </h2>
                                </div>
                                <div className="col">
                                    <h2 className="card-title">
                                        Total avec filtre : <b className="text-success">{paginatedCashIns ? paginatedCashIns.length : 0} </b>
                                    </h2>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-4">
                                    <label htmlFor="source" className="text-dark">Recherche par source</label>
                                    <div className="form-group mt-3">
                                        <select
                                            className="form-control mb-2"
                                            //size={(buses.length)}
                                            name="source"
                                            id="source"
                                            value={search}
                                            onChange={handleSearch}
                                        >

                                            <option value="">Choisir..</option>
                                            <option value="">TOUTES LES SOURCES</option>
                                            {sources && sources.map((account) => (
                                                <option key={account.id} value={account.name}>
                                                    {account.name}</option>
                                            ))
                                            }
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-2">
                                    <div className="form-group mt-3">
                                        <label htmlFor="ByAll" className="text-dark">
                                            Date debut
                                        </label>
                                        <input type="date" onChange={handleStartedDate} value={startAt}
                                               name="startDate" id="startDate" autoComplete="off" className="form-control" placeholder="Rechercher ..."
                                        />
                                    </div>
                                </div>
                                <div className="col-md-2">
                                    <div className="form-group mt-3">
                                        <label htmlFor="endDate" className="text-dark">
                                            Date fin
                                        </label>
                                        <input type="date" onChange={handleEndedDate} value={endAt}
                                               name="endDate" id="endDate" autoComplete="off" className="form-control" placeholder="Rechercher ..."
                                        />
                                    </div>
                                </div>
                                <div className="col-md-1">
                                    <div className="form-group mt-3">
                                        <button onClick={handleBtns} className="mt-4 btn btn-primary">Filtrer</button>
                                    </div>
                                </div>
                                <div className="col-md-2">
                                    <div className="form-group mt-4 d-flex float-end">
                                        <PrinterCashier devise={"ALL"} param={param} type={"in"} endAt={endAt} startAt={startAt}  critere={search} data={filteredCashIns} />
                                    </div>
                                </div>
                            </div>

                            <hr/>
                            <table className="table table-hover table-striped">
                                <thead>
                                <tr>
                                    <th scope="col">#</th>
                                    <th scope="col" colSpan="3">Code</th>
                                    <th scope="col">Source</th>
                                    <th scope="col">Montant</th>
                                    <th scope="col">Devise</th>
                                    <th scope="col">Date</th>
                                    <th scope="col">Options</th>
                                </tr>
                                </thead>
                                {!loading &&<tbody>
                                {paginatedCashIns.map((cashIn) => (
                                    <tr key={cashIn.id}>
                                        <td>{counter++}</td>
                                        <td colSpan="3"><b className="text-success">{cashIn.code}</b></td>
                                        <td>{cashIn.source}</td>
                                        <td><b>{cashIn.amount}</b></td>
                                        <td>{cashIn.currency}</td>
                                        <td>{Moment(cashIn.created_at).format("DD/MM/YYYY")}</td>
                                        <td>
                                            <Link className="btn btn-sm btn-outline-primary mx-1" to={`/cashier/cashIn/edit/${cashIn.id}`}>
                                                <i className="bi bi-pen-fill"></i>
                                            </Link>
                                        </td>
                                    </tr>
                                ))
                                }

                                </tbody>}
                            </table>
                            {loading && <TableLoader width={300} height={350} />}

                            <div className="invoice-price">
                                <div className="invoice-price-left">
                                    <div className="invoice-price-row">
                                        <div className="sub-price">
                                            {/*<small>SUBTOTAL</small>*/}
                                            <span className="text-inverse"></span>
                                        </div>
                                        <div className="sub-price">
                                            <i className="fa fa-plus text-muted"></i>
                                        </div>
                                        <div className="sub-price">
                                            {/*<small>TAX (5.4%)</small>*/}
                                            <span className="text-inverse"></span>
                                        </div>
                                    </div>
                                </div>
                                <div className="invoice-price-right">
                                    <small>TOTAL</small>
                                    {/*<NumericFormat value={(calculTotalAllCurrency(filteredCashIns).totalCDF).toFixed(2)} displayType={'text'} thousandSeparator={true} suffix={' FC'} /> <br/>*/}
                                    {/*<NumericFormat value={(calculTotalAllCurrency(filteredCashIns).totalUSD).toFixed(2)} displayType={'text'} thousandSeparator={true} suffix={' $'} />*/}
                                    <span className="f-w-700"> {filteredCashIns && calculTotalAllCurrency(filteredCashIns).totalCDF > 0 && calculTotalAllCurrency(filteredCashIns).totalCDF} FC</span> <br/>
                                    <span className="f-w-700"> {filteredCashIns && calculTotalAllCurrency(filteredCashIns).totalUSD > 0  && calculTotalAllCurrency(filteredCashIns).totalUSD} $</span>
                                </div>
                            </div>

                            <br/>

                            {itemsPerPage < filteredCashIns.length &&
                                <Pagination
                                    currentPage={currentPage}
                                    itemsPerPage={itemsPerPage}
                                    length={filteredCashIns.length}
                                    onPageChange={handleChangeCurrentPage}
                                />
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RapportCashIn;
